import { debounce } from 'lodash';

import { mapboxgl, MixpanelTrackEventFnType } from '@project44/ui-utils';

import { scopedT } from '../../../../utils/helpers/scopedT';

const DEBOUNCE_DELAY = 1000;
export const MVMT_SHIPMENT_ENTITY_ADJUST_MAP =
  'MVMT_SHIPMENT_ENTITY_ADJUST_MAP';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const callback = (fn: (args: any) => void) => {
  return debounce(fn, DEBOUNCE_DELAY);
};

const trackMapAdjustEvent = (
  trackFn: MixpanelTrackEventFnType,
  properties: Record<string, unknown>,
) => {
  trackFn({ eventName: MVMT_SHIPMENT_ENTITY_ADJUST_MAP, properties });
};

export const trackMapEvents = (
  trackFn: MixpanelTrackEventFnType,
  map: mapboxgl.Map,
  totalPlottableRouteStops = 0,
) => {
  const t = scopedT();

  const trackZoomEvents = callback((data) => {
    const e = data?.originalEvent;
    if (!e) return;

    let adjustmentType = '';
    if (e.wheelDelta) {
      adjustmentType = e.wheelDelta > 0 ? 'zoom-in' : 'zoom-out';
    } else if (e.target) {
      const btnTitle = e.target.getAttribute('title');
      adjustmentType = btnTitle === t('map.zoomIn') ? 'zoom-in' : 'zoom-out';
    }

    if (!adjustmentType) {
      console.warn(
        'Map events tracking: Failed to determine mapbox zoom direction',
      );
    }

    adjustmentType &&
      trackMapAdjustEvent(trackFn, {
        adjustmentType,
        totalPlottableRouteStops,
      });
  });

  const trackRotateEvents = callback(() => {
    trackMapAdjustEvent(trackFn, {
      adjustmentType: 'orient',
      totalPlottableRouteStops,
    });
  });

  const trackDragEvents = callback(() => {
    trackMapAdjustEvent(trackFn, {
      adjustmentType: 'drag',
      totalPlottableRouteStops,
    });
  });

  map.on('zoom', trackZoomEvents);
  map.on('rotate', trackRotateEvents);
  map.on('dragend', trackDragEvents);

  return () => {
    map.off('zoom', trackZoomEvents);
    map.off('rotate', trackRotateEvents);
    map.off('dragend', trackDragEvents);
  };
};
